import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconCheckRound: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6889 0.5C4.89923 0.5 0.188873 5.21036 0.188873 11C0.188873 16.7896 4.89923 21.5 10.6889 21.5C16.4785 21.5 21.1889 16.7896 21.1889 11C21.1889 5.21036 16.4785 0.5 10.6889 0.5ZM16.1534 7.48099L9.3688 15.5579C9.21822 15.7373 8.99719 15.8424 8.76303 15.8462H8.7494C8.52045 15.8461 8.3023 15.7488 8.14919 15.5786L5.24149 12.3478C4.93548 12.0233 4.95053 11.5121 5.27509 11.2061C5.59966 10.9001 6.11084 10.9151 6.41685 11.2397C6.42542 11.2488 6.43378 11.2581 6.44193 11.2675L8.7282 13.8077L14.9166 6.44209C15.2085 6.10471 15.7185 6.06777 16.0559 6.35959C16.3864 6.64546 16.4296 7.14236 16.1534 7.48099L16.1534 7.48099Z" />
    </svg>
  </IconStyled>
);

IconCheckRound.defaultProps = iconDefaultProps;
IconCheckRound.displayName = 'IconCheckRound';

export default IconCheckRound;
